import { Map } from 'leaflet';
import { useLeaflet } from 'react-leaflet';

export const useMap = (): Map => {
  const leaflet = useLeaflet();
  return leaflet.map as Map;
};
